import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { ChemIDSearchField } from "../../../components/ChemIDSearch/index";
import { styled } from "@mui/material/styles";
import { UXDataTable } from "../../../components/UXDataTable";
import SubstanceSubcomponent from "../../../api/LIMS/SubstanceSubcomponent";
import Substance from "../../../api/LIMS/Substance";
import { convertToLocalTime, displayPHSValue } from "../../../global";
import ModalSimpleButton from '../../../components/Modal/ModalSimpleButton';

  
const subSubstance = [
  {
    field: "percentageCompositionUpper",
    headerName: "Quantity",
    type: "number",
  },
  { field: "subcomponentChemID", headerName: "ChemID", type: "label" },
  { field: "substanceName", headerName: "Description", type: "label" },
  { field: "nfpa", headerName: "NFPA", type: "label" },
  { field: "hmis", headerName: "HMIS", type: "label" },
  { field: "phs", headerName: "PHS", type: "label" }
];

const LineBox = styled(Box)({
  height: "30px",
  width: "50%",
  display: "flex",
  minWidth: "500px",
});
const SpanTitle = styled("span")({
  width: "30%",
  display: "flex",
  height: "30px",
  backgroundColor: "#2567c349",
  borderBottom: "1px solid white",
  alignItems: "center",
  paddingLeft: "10px",
});
const SpanValue = styled("span")({
  width: "70%",
  height: "30px",
  display: "flex",
  borderBottom: "1px solid #2567c349",
  alignItems: "center",
  paddingLeft: "10px",
});
const LineBoxTable = styled(Box)({
  width: "50%",
  display: "flex",
  minWidth: "500px",
});
const SpanTitleTable = styled("span")({
  width: "30%",
  display: "flex",
  backgroundColor: "#2567c349",
  borderBottom: "1px solid white",
  alignItems: "center",
  paddingLeft: "10px",
});
const SpanValueTable = styled("span")({
  width: "70%",
  display: "flex",
  borderBottom: "1px solid #2567c349",
  paddingLeft: "10px",
});
const NewFormBtn = styled(Box)({
  textDecoration: "underline",
  color: "blue",
  cursor: "pointer",
  width: "fit-content",
});
const ThStyled = styled("th")({
  textAlign: "center",
  padding: "0px 2px"
});
const TableStyled = styled("table")({
  margin: "5px 0px",
});
const TdStyled = styled("td")({
  textAlign: "center",
});
const PStyled = styled("p")({
  fontSize: "14px",
});

const RightToKnow = ({ setTabValue }) => {
  const [hasChemIDErrors, setHasChemIDErrors] = useState(false);
  const [substanceUsage, setSubstanceUsage] = useState(true);
  const [selectedChemID, setSelectedChemID] = useState(null);
  const [listSubcomponent, setListSubcomponent] = useState([]);

  const [modalSimpleButton, setModalSimpleButton] = React.useState(false);
  const [modalSimpleButtonText, setModalSimpleButtonText] = React.useState('');
  const [modalSimpleTitle, setModalSimpleTitle] = React.useState('');
  const [modalSimpleText, setModalSimpleText] = React.useState('');

  const QuantityComposition = (substance) => {
    if (
      substance.percentageCompositionUpper ===
      substance.percentageCompositionLower
    )
      return substance.percentageCompositionUpper != null ? substance.percentageCompositionUpper.toFixed(5) : "";

    if (substance.percentageCompositionLower === 0)
      return `< ${substance.percentageCompositionUpper != null ? substance.percentageCompositionUpper.toFixed(5) : ""}`;

    if (substance.percentageCompositionUpper === 100)
      return `> ${substance.percentageCompositionLower != null ? substance.percentageCompositionLower.toFixed(5) : ""}`;
    else
      return `${substance.percentageCompositionLower != null ? substance.percentageCompositionLower.toFixed(5) : ""} - ${substance.percentageCompositionUpper != null ? substance.percentageCompositionUpper.toFixed(5) : ""}`;
  };

  useEffect(() => {
    if (!selectedChemID || !selectedChemID.chemID) return;
    SubstanceSubcomponent.get(selectedChemID.chemID).then((substances) => {
      let rows = [];
      let getAllSubSubstances = substances.map((element) => {
        return Substance.getByChemID(element.subcomponentChemID, false, false).then((res) => {
          return res && res.message === 'Success' ? res.result : null;
        });
      });
      Promise.all(getAllSubSubstances).then((result) => {
        result.forEach((element) => {
          let currentSubSubstance = substances.find(
            (x) => x.subcomponentChemID === element.chemID
          );
          if(element.nfpah == null ){
            element.nfpah = "-"
          }
          if(element.nfpaf == null ){
            element.nfpaf = "-"
          }
          if(element.nfpar == null ){
            element.nfpar = "-"
          }
          if(element.hmish == null ){
            element.hmish = "-"
          }
          if(element.hmisf == null ){
            element.hmisf = "-"
          }
          if(element.hmisr == null ){
            element.hmisr = "-"
          }
   
          rows.push({
            percentageCompositionUpper:
              QuantityComposition(currentSubSubstance),
            subcomponentChemID: element.chemID ?? "",
            substanceName: element.substanceName ?? "",
            nfpa: <>
              <PStyled>H {element.nfpah}</PStyled>
              <PStyled>F {element.nfpaf}</PStyled>
              <PStyled>R {element.nfpar}</PStyled>
            </>,
            hmis: <>
            <PStyled>H {element.hmish}</PStyled>
            <PStyled>F {element.hmisf}</PStyled>
            <PStyled>R {element.hmisr}</PStyled>
            </>,
            phs: displayPHSValue(element),
            order: currentSubSubstance.percentageCompositionUpper,
          });
        });
        setListSubcomponent(rows);
      });
    });
  }, [selectedChemID]);

  async function usageCheck(chemID) {
    if (chemID) {
      const response = await Substance.usageCheck(chemID)
      setSubstanceUsage(response);
    }
  }

  const downloadSDS = async (chemId) => {
    if (chemId) {
      const response = await Substance.getSDSFilePath(chemId)
      if (response?.result?.sdsFilePath?.trim()) {
        window.open(response.result.sdsFilePath, '_blank');
      } else {
        openModalSimpleButton('Fail', 'There is no valid PSIMS ID associated with this Chem ID.', 'Ok');
      }
    }
  }

  function openModalSimpleButton(title, text, buttonText) {
      setModalSimpleButtonText(buttonText)
      setModalSimpleButton(true);
      setModalSimpleTitle(title);
      setModalSimpleText(text);
  }

  function closeModalSimpleButton() {
      setModalSimpleButton(false);
  }

  return (
    <div>
      <Box>
        <ChemIDSearchField
          fontSize={14}
          fieldWidth="50%"
          selectedChemIDObject={selectedChemID}
          setSelectedChemIDObject={(e) => {
            setListSubcomponent([]);
            if(e != null){
              setSelectedChemID(e)
              usageCheck(e.chemID)
            }
            else{
              setSelectedChemID(e)
            }            
          }}
          hasErrors={hasChemIDErrors}
          setHasErrors={setHasChemIDErrors}
          allowInactiveChemIDs={true}
          returnSubstanceStrucureData={false}
        />
      </Box>
      <br />
      <Box>
        <LineBox>
          <SpanTitle>Chem ID</SpanTitle>
          <SpanValue>{selectedChemID?.chemID ?? ""}</SpanValue>
        </LineBox>
        <LineBox>
          <SpanTitle>Chem ID Category</SpanTitle>
          <SpanValue>{selectedChemID?.chemIDCategoryName ?? ""}</SpanValue>
        </LineBox>
        <LineBox>
          <SpanTitle>Status</SpanTitle>
          <SpanValue>
            {selectedChemID
              ? selectedChemID?.isActive
                ? "Active"
                : "Inactive"
              : ""}
          </SpanValue>
        </LineBox>
        <LineBox>
          <SpanTitle>Description</SpanTitle>
          <SpanValue>{selectedChemID?.substanceName ?? ""}</SpanValue>
        </LineBox>
        <LineBoxTable>
          {selectedChemID ? <SpanTitleTable>HFR</SpanTitleTable> : <SpanTitle>HFR</SpanTitle>}
          <SpanValueTable>
          {selectedChemID &&<TableStyled>
            <thead>
              <tr>
                <ThStyled></ThStyled>
                <ThStyled>NFPA</ThStyled>
                <ThStyled>HMIS</ThStyled>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>H</td>
                <TdStyled>{selectedChemID?.nfpah ==  null ? "-" : selectedChemID?.nfpah}</TdStyled>
                <TdStyled>{selectedChemID?.hmish  ==  null ? "-" : selectedChemID?.hmish}</TdStyled>
              </tr>
              <tr>
                <td>F</td>
                <TdStyled>{selectedChemID?.nfpaf ==  null ? "-" : selectedChemID?.nfpaf}</TdStyled>
                <TdStyled>{selectedChemID?.hmisf  ==  null ? "-" : selectedChemID?.hmisf }</TdStyled>
              </tr>
              <tr>
                <td>R</td>
                <TdStyled>{selectedChemID?.nfpar == null ?  "-" : selectedChemID?.nfpar }</TdStyled>
                <TdStyled>{selectedChemID?.hmisr  ==  null ? "-" : selectedChemID?.hmisr }</TdStyled>
              </tr>
            </tbody>
          </TableStyled>}
          </SpanValueTable>
          {/* {selectedChemID ? displayNfpaHmisHFRValue(selectedChemID) : ""} */}
        </LineBoxTable>
        <LineBox>
          <SpanTitle>PHS</SpanTitle>
          <SpanValue>
            {selectedChemID ? displayPHSValue(selectedChemID) : ""}
          </SpanValue>
        </LineBox>
        <LineBox>
          <SpanTitle>Peroxidizable</SpanTitle>
          <SpanValue>
            {selectedChemID
              ? selectedChemID?.isPeroxidizable
                ? "Y"
                : "N"
              : ""}
          </SpanValue>
        </LineBox>
        <LineBox>
          <SpanTitle>Replacement Chem ID</SpanTitle>
          <SpanValue>{selectedChemID?.promotedChemID ?? ""}</SpanValue>
        </LineBox>
        <LineBox>
          <SpanTitle>Default Retention Period (Months)</SpanTitle>
          <SpanValue>
            {selectedChemID?.smgDefaultRetentionMonths ?? ""}
          </SpanValue>
        </LineBox>
        <LineBox>
          <SpanTitle>Safety Information Last Updated</SpanTitle>
          <SpanValue>
            {selectedChemID && selectedChemID?.lastSafetyModifiedByEmail && selectedChemID?.lastSafetyModifiedDate
              ? `${selectedChemID?.lastSafetyModifiedByEmail ?? "Unknown"
              } on ${convertToLocalTime(
                new Date(selectedChemID?.lastSafetyModifiedDate)
              )}`
              : ""}
          </SpanValue>
        </LineBox>
        <LineBox>
          <SpanTitle>Owner</SpanTitle>
          <SpanValue>{selectedChemID?.ownerEmail ?? ""}</SpanValue>
        </LineBox>
        <LineBox>
          <SpanTitle>SDS</SpanTitle>
          {
            selectedChemID && selectedChemID?.chemID && selectedChemID?.psimsid
            ? <SpanValue style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
            onClick={() => downloadSDS(selectedChemID?.chemID)}>Download SDS - PSIMS ID: {selectedChemID?.psimsid}</SpanValue>
            : <SpanValue></SpanValue>
          }
        </LineBox>
      </Box>
      <br />

      {!substanceUsage && <Box display={'flex'} gap={'10px'}>
        <NewFormBtn
          onClick={() => {
            setTabValue(2);
          }}
        >
          New Chemical Review Form
        </NewFormBtn>
        <span style={{ fontSize: 14, color: "red" }}>(This container has not been used in the last 3 years.  Please complete a new NCA form.)</span>
      </Box>}
      <br />
      {/* {selectedChemID && selectedChemID.psimsid && (
        <>
          <a
            rel="noreferrer"
            target="_blank"
            href="https://apps.spheracloud.net/Pdf/3461510_1_615691557.pdf"
          >
            View SDS
          </a>
          <br />
          <br />
        </>
      )} */}

      <UXDataTable
        tableWidth="60%"
        cols={subSubstance}
        rows={
          selectedChemID
            ? listSubcomponent.sort((a, b) => a.order - b.order)
            : []
        }
        moreOptionsCell={false}
        enablePaging={true}
        noDataMessage={""}
        menuProps={null}
        defaultRowsPerPage={25}
        isDataLoading={false}
        tableName={"allStudies"}
        enableSorting={true}
      ></UXDataTable>

        <ModalSimpleButton title={modalSimpleTitle} buttonText={modalSimpleButtonText} buttonAction={closeModalSimpleButton} open={modalSimpleButton} setOpen={setModalSimpleButton}>
            <label>
                {modalSimpleText}
            </label>
        </ModalSimpleButton>
      <br />
    </div>
  );
};

export default RightToKnow;
